module.exports = __webpack_public_path__ + "media/images/illust/illust-couple-0091b5f37a8acf36c1048a2220a1a7b6.svg";